import { Form, Spin, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
    AppLevelConfigPagedList,
    AppLevelConfigPayload,
    getAllAppSourceConfig,
    MstRequest,
} from 'api/master';
//import { LoadingScreen } from 'common/components';
import moment from 'moment';
import { useEffect, useState, useRef } from 'react';


type Props = {
    filter: MstRequest;
    onSubmit: (values: AppLevelConfigPayload) => Promise<void>;
};

// Initialized fallback object prevents the component from starting with pagedList as 'undefined'
const initialPagedList: AppLevelConfigPagedList = {
    data: [],
    noOfRecords: 0,
    currentPageIndex: 1,
};
// let applevelConfigPagedList: AppLevelConfigPagedList;


const Applevellist = ({ filter }: Props) => {
    const [_form] = Form.useForm<AppLevelConfigPayload>();
    // const [pagedList, setPagedList] = useState(applevelConfigPagedList);
    const [pagedList, setPagedList] = useState(initialPagedList);
    const [isTableLoading, setIsTableLoading] = useState(true);
    //const [isLoading, setIsLoading] = useState(true);
    //const [_isRetry, setRetry] = useState(false);

    //const isAdmin = sessionStorage.getItem('isAdmin');

    const isFetchingRef = useRef(false);
    const lastFilterRef = useRef(''); // 👈 3. Added ref lock token

    useEffect(() => {
        // 👈 4. Lock Check: Exit immediately if this exact filter already ran
        const filterStr = JSON.stringify(filter);

        // 👈 2. Block if identical query OR if a request is already actively processing
        if (lastFilterRef.current === filterStr || isFetchingRef.current) {
            return;
        }
        lastFilterRef.current = filterStr;
        isFetchingRef.current = true; // Lock in-flight call

        //setIsLoading(false);
        //setPagedList(applevelConfigPagedList);
        setIsTableLoading(true);

        // filter.pageNo = 1;
        // filter.pageSize = 10;
        debugger;

        // 👈 5. Clone payload instead of mutating prop directly
        const reqPayload = { ...filter, pageNo: 1, pageSize: 10 };

        getAllAppSourceConfig(reqPayload)
            .then((res) => {
                setPagedList(res.data);
                // setIsLoading(true);
                debugger;
            })
            .finally(() => {
                //setIsLoading(true);
                setIsTableLoading(false);
                isFetchingRef.current = false;
            });
    }, [JSON.stringify(filter)])


    const columns: ColumnsType<AppLevelConfigPayload> = [
        {
            key: 'sourceApplicationName',
            title: 'Source Application Name',
            dataIndex: 'sourceApplicationName',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
            className: '',
        },
        {
            key: 'configKey',
            title: 'Configuration Name',
            dataIndex: 'configKey',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'configValue',
            title: 'Configuration Value',
            dataIndex: 'configValue',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'createdBy',
            title: 'Created By',
            dataIndex: 'createdBy',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'createdOn',
            title: 'Created On',
            dataIndex: 'createdOn',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={moment(record).format('DD/MM/YYYY HH:mm:ss')}>
                    {moment(record).format('DD/MM/YYYY HH:mm:ss')}
                </Tooltip>
            ),
        },
        {
            key: 'flag',
            title: 'Flag',
            dataIndex: 'flag',
            ellipsis: true,
            render: flag => flag ? 'Active' : 'InActive',
        },
    ];

    // if (!pagedList || !isLoading) {
    //     return <LoadingScreen />;
    // }

    const handleChange = (_pagination: any, _filters: AppLevelConfigPayload, sorter: any) => {
        // setIsLoading(false);
        setIsTableLoading(true); // Starts table spinner on page switch

        if (sorter.hasOwnProperty('column')) {
            // params.order = { field: sorter.field, dir: sorter.order };
        }
        // filter.pageNo = _pagination.current;
        // filter.pageSize = _pagination.pageSize;

        // 👈 7. Cloned payload for pagination change
        const paginationPayload = {
            ...filter,
            pageNo: _pagination.current,
            pageSize: _pagination.pageSize
        };

        getAllAppSourceConfig(paginationPayload).then((res) => {
            setPagedList(res.data);
            //            setIsLoading(true);
            setIsTableLoading(false);
        });
    };

    const maxWidthPerCell = 1000;

    const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
    const tableHeight = 500;
    const rowKey = 'ROWNUM';

    //const totalPages = Math.ceil(pagedList.noOfRecords / 10);

    return (
        <>
            <Spin spinning={isTableLoading}>
                <Table
                    columns={dataTable.columns}
                    dataSource={dataTable.source}
                    rowKey={rowKey}
                    scroll={{ x: dataTable.tableWidth, y: tableHeight }}
                    pagination={{
                        pageSize: 10,
                        total: pagedList.noOfRecords,
                        current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
                    }}
                    onChange={handleChange}
                />
            </Spin>
            ;
        </>
    );
};

export default Applevellist;
